var CallableMessages = /** @class */ (function () {
    //Singleton class
    function CallableMessages() {
        if (!CallableMessages._instance) {
            CallableMessages._instance = this;
        }
        return CallableMessages._instance;
    }
    /// Reloads flutter build
    CallableMessages.prototype.reloadFlutterBuild = function () {
        var _a;
        window.flutterIframeWindow && ((_a = window.flutterIframeWindow) === null || _a === void 0 ? void 0 : _a.triggerReloadFlutter());
    };
    /// Open susbcription pop up
    CallableMessages.prototype.openSubscriptionPopup = function (reloadFlutterOnClose) {
        var _a;
        if (reloadFlutterOnClose === void 0) { reloadFlutterOnClose = false; }
        window.flutterIframeWindow && ((_a = window.flutterIframeWindow) === null || _a === void 0 ? void 0 : _a.triggerShowSubscriptionPopup(reloadFlutterOnClose));
    };
    return CallableMessages;
}());
export default CallableMessages;
